import {URL_BASE} from "@/configs/constants";
import axios from "axios";

const RESOURCE = "spot-list-site"

export default {
    actions: {
        loadSpots() {
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}${RESOURCE}`)
                    .then((response) => {
                        return resolve(response.data)
                    }).catch((error) => {
                    return reject(error)
                })
            })
        }
    }
}